import React from 'react';
import { useStrip } from '../hooks/useStrip';
import { squareToPixel } from '../utils/graph.utils';
import { WaveBar } from './WaveBar';
import { Wave } from '../../wave/types/wave.type';

const WAVE_BAR_HEIGHT = squareToPixel(1 / 5);

interface Props {
  waves: Wave[];
}

export const ManualDelineationBar: React.FC<Props> = ({ waves }) => {
  const { height } = useStrip();

  return (
    <g
      className='manual-delineation'
      style={{ transform: `translate(0px, ${height - WAVE_BAR_HEIGHT}px)` }}
    >
      {waves.map((wave) => (
        <WaveBar key={wave.id} waveId={wave.id} height={WAVE_BAR_HEIGHT} />
      ))}
    </g>
  );
};
